<template>
<div>
    <v-card max-width="620px" flat class="mx-auto">
        <div class="px-5 py-6 d-flex align-center justify-space-between" :style="{backgroundColor: user.color}">
            <div class="d-flex align-center">
                <v-icon color="white" small class="mr-3">fa-file</v-icon>
                <div class="white--text title font-weight-regular">Personal Stuff</div>
            </div>

            <div>
                <v-btn class="grey--text text--darken-4  white" @click="showPF=true">
                    <v-icon :color="user.color" small left>fa-file-alt</v-icon>
                    Upload file
                </v-btn>
            </div>
        </div>

        <div v-if="work.length > 0 && loaded" style="border: 1px solid #CCCCCC">
            <div v-for="(it, index) in work" :key="it.id">
                <v-row>
                    <v-col col="12" sm="6" md="4">
                        <div class="text-center">
                            <v-btn fab depressed class="mt-2 white" :href="it.url">
                                <v-icon :color="user.color">fa-file-download</v-icon>
                            </v-btn>
                        </div>
                    </v-col>

                    <v-col col="12" sm="6" md="8">
                        <div class="subtitle-1 font-weight-medium mt-1" style="line-height:1.1">
                            {{it.title}}
                        </div>
                        <div class="caption grey--text text--darken-1">
                            {{it.formattedDate}}
                        </div>
                        <div class="body-2" style="line-height:1.3">
                            {{it.description}}
                        </div>
                        <!-- <div style="width:170px">
                            <v-divider class="mt-2"></v-divider>
                        </div> -->
                        <!-- <div>
                            <v-btn text class="grey--text text--darken-2 ml-n2">
                                <v-icon small left :color="user.color">fa-comment-dots</v-icon>
                                <span style="font-size:10px">Comments ({{it.comments.length}})</span>
                            </v-btn>
                        </div> -->
                    </v-col>
                </v-row>

                <div class="d-flex justify-center" v-if="index<work.length-1">
                    <v-divider></v-divider>
                </div>
            </div>
        </div>

        <div>
            <SendingLoader v-if="!loaded" />
        </div>

        <div class="caption text-center font-weight-medium grey--text text--darken-2 px-3 py-12" v-if="work.length == 0 && loaded">
            NO FILES UPLOADED YET.
        </div>
    </v-card>

    <DiagWork 
        :model="showPF"
        @cancel="showPF=false"
        @close="reinit"/>
</div>
</template>

<script>
import FormatDate from '@/services/formatDate'
import DiagWork from '@/components/core/dialogs/DiagWork'
import Work from '@/firebase/work'

export default {
    data: () => ({
        loaded: true,
        showPF: false,
        work: []
    }),
    props: ['item'],
    components: {
        DiagWork
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit() {
            this.work = [];
            this.showPF = false;
            this.init();
        },
        init() {
            Work.getAll(this.user.uid)
                    .then(response => {
                        if (response.status === true) {
                            response.query.forEach(dt => {
                                let tempo = dt.data();
                                tempo.id = dt.id;
                                tempo.formattedDate = FormatDate.getFormatted(tempo.date);
                                tempo.comments = [];
                                this.work.push(tempo);
                            }),
                            this.work = _.orderBy(this.work, 'date', 'desc');
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>